// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "th[data-v-56431154]{background-color:#f5f5f5;white-space:nowrap;color:#404040}td[data-v-56431154]{background-color:#fff;color:#252525}table[data-v-56431154]{width:100%;font-size:12px;font-weight:500}th[data-v-56431154]{width:20%}.notice[data-v-56431154]{color:#dc5353;font-weight:700;font-size:12px;padding-top:12px;padding-bottom:12px}.label[data-v-56431154]{padding:2px 0 2px 2px;font-size:12px}", ""]);
// Exports
module.exports = exports;
